import { useEffect, useState } from 'react';

export default function FilterChange({
  filters,
  selectedKeys = [],
  maxSelection = 4,
  onApply,
  onClose
}) {
  const [tempSelection, setTempSelection] = useState(selectedKeys);

  useEffect(() => {
    setTempSelection(selectedKeys);
  }, [selectedKeys]);

  const toggleSelection = (key) => {
    const isSelected = tempSelection.includes(key);
    if (isSelected) {
      setTempSelection((prev) => prev.filter((item) => item !== key));
      return;
    }

    if (tempSelection.length >= maxSelection) {
      return;
    }

    setTempSelection((prev) => [...prev, key]);
  };

  const handleApply = () => {
    if (tempSelection.length !== maxSelection) {
      return;
    }
    onApply?.(tempSelection);
  };

  const isApplyDisabled = tempSelection.length !== maxSelection;

  return (
    <div className="absolute right-0 mt-2 w-64 bg-white border border-gray-200 rounded-lg shadow-xl p-4 z-40">
      <div className="flex items-center justify-between mb-2">
        <div className="text-xs text-gray-500">
          최대 {maxSelection}개 선택 ({tempSelection.length}/{maxSelection})
        </div>
        <button
          type="button"
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 text-lg leading-none"
          aria-label="닫기"
        >
          ×
        </button>
      </div>

      <div className="max-h-60 overflow-auto space-y-2 pr-1">
        {filters.map((filter) => {
          const checked = tempSelection.includes(filter.key);
          const disableCheckbox = !checked && tempSelection.length >= maxSelection;
          return (
            <label
              key={filter.key}
              className={`flex items-center gap-2 text-sm ${
                disableCheckbox ? 'text-gray-300 cursor-not-allowed' : 'text-gray-700 cursor-pointer'
              }`}
            >
              <input
                type="checkbox"
                checked={checked}
                onChange={() => toggleSelection(filter.key)}
                disabled={disableCheckbox && !checked}
                className="text-orange-500 rounded focus:ring-orange-500"
              />
              <span>{filter.label}</span>
            </label>
          );
        })}
      </div>

      <div className="mt-3 flex items-center justify-between gap-2">
        <button
          type="button"
          onClick={onClose}
          className="flex-1 px-3 py-1.5 text-sm border border-gray-300 rounded-md hover:bg-gray-50"
        >
          취소
        </button>
        <button
          type="button"
          onClick={handleApply}
          disabled={isApplyDisabled}
          className={`flex-1 px-3 py-1.5 text-sm font-semibold rounded-md text-white ${
            isApplyDisabled ? 'bg-orange-200 cursor-not-allowed' : 'bg-orange-500 hover:bg-orange-600'
          }`}
        >
          적용
        </button>
      </div>

      {isApplyDisabled && (
        <p className="mt-2 text-[0.875rem] text-gray-500">필터 {maxSelection}개를 선택해주세요.</p>
      )}
    </div>
  );
}

